import {ChangeEvent, HTMLAttributes, useState} from 'react';
import styled from 'styled-components';
import {USER_EXTRA_INFO_STEPS} from '@/constants';
import {UserCategoryType, UserProfileType} from '@/enums';
import {ColumnFlexBox, FlexFullGrow} from '@/styled-components';
import {palette} from '@/styles';
import {Button} from '../Button';
import {Dropdown} from '../Dropdown';
import {TextField} from '../TextField';
import {Typography} from '../Typography';
import {InputContainer} from './StyledComponents';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  defaultValues?: {[key: string]: any};
  onComplete(value: {[key: string]: any}): void;
}

const MIN_OTHER_COUNT = 2;
const MAX_OTHER_COUNT = 500;

export const ExtraInfoStep = ({
  defaultValues,
  onComplete,
  ...props
}: IProps) => {
  const [values, setValues] = useState<{[key: string]: any}>(
    defaultValues || {}
  );

  const onSelected = (
    id: string,
    selected: Array<{label: string; id: any}>
  ) => {
    setValues((prev) => {
      const next = selected?.[0]?.id;

      if (
        prev[UserCategoryType.Other] === UserCategoryType.Other &&
        next !== UserCategoryType.Other
      ) {
        prev[UserProfileType.otherCategory] = undefined;
      }

      return {
        ...prev,
        [id]: next,
      };
    });
  };

  const onTextFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {value, name} = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onClick = () => {
    onComplete(values);
  };

  const showTextfield =
    values[UserProfileType.category] === UserCategoryType.Other;
  const isValid =
    Object.keys(values).length >= USER_EXTRA_INFO_STEPS.length &&
    (!showTextfield ||
      values[UserProfileType.otherCategory]?.length > MIN_OTHER_COUNT);

  return (
    <Form {...props}>
      {USER_EXTRA_INFO_STEPS.map((i) => (
        <ColumnFlexBox key={i.id} gap={12}>
          <Dropdown
            label={i.label}
            multi={i.isMulti}
            required
            placeholder="선택해주세요"
            list={i.options}
            selected={
              values[i.id]
                ? i.options.filter((j) => j.id === values[i.id])
                : undefined
            }
            onSelected={(selected) => onSelected(i.id, selected)}
          />
          {i.id === UserProfileType.category && showTextfield && (
            <ColumnFlexBox gap={4}>
              <TextField
                variant="large"
                fullWidth
                placeholder="기타에 해당하시는 경우 자세히 알려주세요."
                maxLength={MAX_OTHER_COUNT}
                name={UserProfileType.otherCategory}
                value={values[UserProfileType.otherCategory]}
                height={44}
                fontSize={16}
                onChange={onTextFieldChange}
              />
              <Typography
                as="div"
                variant="paragraph12"
                lineHeight="20px"
                color={palette.gray600}
              >
                최소 {MIN_OTHER_COUNT}자~ 최대 {MAX_OTHER_COUNT}자
              </Typography>
            </ColumnFlexBox>
          )}
        </ColumnFlexBox>
      ))}
      <FlexFullGrow />
      <Button
        disabled={!isValid}
        variant="fill"
        color="primary"
        size="mediumLarge"
        fullWidth
        onClick={onClick}
      >
        다음
      </Button>
    </Form>
  );
};

const Form = styled(InputContainer)`
  gap: 28px;
`;
